import { render, staticRenderFns } from "./ModuleStart.vue?vue&type=template&id=1861cebe&scoped=true&"
import script from "./ModuleStart.vue?vue&type=script&lang=js&"
export * from "./ModuleStart.vue?vue&type=script&lang=js&"
import style0 from "./ModuleStart.vue?vue&type=style&index=0&id=1861cebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861cebe",
  null
  
)

export default component.exports